var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9999 0C74.9999 0 49.9999 25.1698 49.8301 37.1022C49.6602 49.0346 72.6561 72.6561 72.6561 72.6561C72.6561 72.6561 49.8301 49.8301 37.1022 49.8301C24.3743 49.8301 0 74.9999 0 74.9999C0 74.9999 25.1698 49.8301 25.1698 37.8977C25.1698 25.9653 2.34374 2.34374 2.34374 2.34374C2.34374 2.34374 23.7954 25.1698 37.8977 25.1698C51.9999 25.1698 74.9999 0 74.9999 0Z",
    fill: "#E29C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape2.d50021cf5a10d7427893a88789b59c64.svg";
export { ForwardRef as ReactComponent };